import { lazy } from 'react';

import Loadable from 'ui-component/Loadable';
import PartnerLayout from 'layout/PartnerLayout';
import { PartnerAuthProvider } from 'contexts/PartnerAuthContext';
import PartnerProtected from 'views/pages/partner/PartnerProtected';

const PartnerLandingPage = Loadable(lazy(() => import('views/pages/partner/PartnerLandingPage')));
const WatchPage = Loadable(lazy(() => import('views/pages/watch')));
const RacingPage = Loadable(lazy(() => import('views/pages/betting/index')));
const LuckySign = Loadable(lazy(() => import('views/pages/LuckySign/Bet')));
const ColorSign36 = Loadable(lazy(() => import('views/pages/ColorSign36/GamePlayColorSign36')));
const PayoutPage = Loadable(lazy(() => import('views/pages/payment/payout')));
const TransactionPage = Loadable(lazy(() => import('views/pages/payment/transaction')));
const WinningsTransactionPage = Loadable(lazy(() => import('views/pages/payment/winnings')));
const RaceResults = Loadable(lazy(() => import('views/pages/payment/raceresults')));
const CreateSSOPage = Loadable(lazy(() => import('views/pages/partner/CreateSSOPage')));

/**
 * Marketing-partner route subtree — the ROOT of the standalone MP app.
 *
 * URL shape (served under basename `/mp`):
 *   /mp/:mpId                                  → landing
 *   /mp/:mpId/racing|marbleracing|fixedracing/:rId/:rNumber/:racingType
 *   /mp/:mpId/fixedracing/luckysign/:id
 *   /mp/:mpId/fixedracing/luckysign36/:id
 *   /mp/:mpId/payout|transactions|winnings|raceresults   (PartnerProtected)
 *
 * Not auth-guarded at the route level: the landing/racing pages render for
 * unauthenticated users; bet placement and the pages below are gated via
 * PartnerProtected + the partner login modal.
 *
 * MIGRATION: page elements are placeholders (ComingSoon) until their step lands:
 *   landing → Step 6 · betting → Step 8 · games → Step 9 · payment → Step 10.
 */
const PartnerRoutes = {
    path: '/mp/:mpId',
    element: (
        <PartnerAuthProvider>
            <PartnerLayout />
        </PartnerAuthProvider>
    ),
    children: [
        { index: true, element: <PartnerLandingPage /> },
        { path: 'watch', element: <WatchPage /> },
        { path: 'racing/:rId/:rNumber/:racingType', element: <RacingPage /> },
        { path: 'marbleracing/:rId/:rNumber/:racingType', element: <RacingPage /> },
        { path: 'fixedracing/:rId/:rNumber/:racingType', element: <RacingPage /> },
        { path: 'fixedracing/luckysign/:id', element: <LuckySign /> },
        { path: 'fixedracing/luckysign36/:id', element: <ColorSign36 /> },
        {
            path: 'payout',
            element: (
                <PartnerProtected>
                    <PayoutPage />
                </PartnerProtected>
            )
        },
        {
            path: 'transactions',
            element: (
                <PartnerProtected>
                    <TransactionPage />
                </PartnerProtected>
            )
        },
        {
            path: 'winnings',
            element: (
                <PartnerProtected>
                    <WinningsTransactionPage />
                </PartnerProtected>
            )
        },
        {
            path: 'create-sso',
            element: (
                <PartnerProtected>
                    <CreateSSOPage />
                </PartnerProtected>
            )
        },
        {
            path: 'raceresults',
            element: (
                <PartnerProtected>
                    <RaceResults />
                </PartnerProtected>
            )
        }
    ]
};

export default PartnerRoutes;
